import React from "react";
import Icon from "../Icon/Icon";
import { useHistory } from "react-router-dom";
import { cn } from "@/shared/utils/cn";

interface Props {
  children?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
const BackButton = ({ children, onClick, className }: Props) => {
  const history = useHistory();
  return (
    <div
      onClick={() => (onClick ? onClick() : history.goBack())}
      className={cn(
        "flex max-w-50 cursor-pointer text-text my-6 md:my-8",
        className
      )}
    >
      <div className="flex items-center justify-center mr-[1rem]">
        <Icon className="h-4 w-4 fill-text" variants="arrowLeft" />
      </div>
      <div className="font-semibold leading-none">{children}</div>
    </div>
  );
};

export default BackButton;
